import './Footer.css';
import logo from '../../assets/logo-no-bg.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLinkedin } from '@fortawesome/free-brands-svg-icons'
import { faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { useState } from 'react';

function Footer() {

  const [showPortfolioOptions, setShowPortfolioOptions] = useState(false);

  const linkedinURL = "https://www.linkedin.com/company/solidtrade/";

  const handleShowPortfolioOptions = () => {
    setShowPortfolioOptions(!showPortfolioOptions);
    };

  return (
    <footer>
        <div className="footer-container">
            <img src={logo} alt="logo" />
            <div className="footer-links">
                <a href="#about">Who We Are</a>
                <a href="#portfolio" className={
                    showPortfolioOptions ? 'show-footer-portfolio-options footer-portfolio-item' : 'footer-portfolio-item'
                } onClick={handleShowPortfolioOptions} style={{ cursor: "pointer" }}>Our Portfolio 
                    <FontAwesomeIcon style={{ marginLeft: "10px", fontSize: "10px", marginBottom: "2px" }} icon={showPortfolioOptions ? faChevronUp : faChevronDown} />
                    <div className='footer-portfolio-options'>
                        <a href="#portfolio" onClick={handleShowPortfolioOptions}>F&B</a>
                        <a href="/real-estate" onClick={handleShowPortfolioOptions}>Real Estate</a>
                        <a href="#pipeline" onClick={handleShowPortfolioOptions}>Other Investments</a>
                    </div>
                </a>
                <a href="/contact">Contact Us</a>
            </div>
            <div className="social-media">
                <a href={linkedinURL} target="_blank" rel="noreferrer">
                    <FontAwesomeIcon icon={faLinkedin} />
                </a>   
            </div>
            <p className="footer-copyright">
                © {new Date().getFullYear()} Solid Investment. All rights reserved.
            </p>
        </div>
    </footer>
  );
}

export default Footer;